import { ElementState } from "@creatomate/preview";
import { CreatomatePropertyValue } from "chq";

const modificationsForAllSubtitles = (
  subtitleElements: ElementState[], property: string, value: CreatomatePropertyValue
) => {
  const result = subtitleElements.map(element => ({
    [`${element.source.id}.${property}`]: value
  })).reduce((acc, obj) => ({ ...acc, ...obj }), {});
  return result;
};

export default modificationsForAllSubtitles;
